import { Compass } from 'lucide-react'
import { Link } from 'react-router-dom'
import { EmptyState } from '../components/ui'

export function NotFoundPage() {
  return <EmptyState icon={<Compass />} title="Такой страницы нет" description="Проверьте адрес или вернитесь к обзору системы." action={<Link className="button button--primary" to="/">Перейти к обзору</Link>} />
}
